import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IpFiltering } from './ip-filtering.model';

@Injectable({
  providedIn: 'root',
})
export class IpFilteringService {
  private isDataChangedSubject: BehaviorSubject<boolean>;
  public isDataChanged$: Observable<boolean>;

  constructor(private http: HttpClient, private toastrService: ToastrService) {
    this.isDataChangedSubject = new BehaviorSubject<boolean>(false);
    this.isDataChanged$ = this.isDataChangedSubject.asObservable();
  }

  createOrUpdateOrDeleteIpFiltering(
    param: IpFiltering,
    isCreateOrUpdateOrDelete: number
  ): Observable<number> {
    return this.http
      .post<number>(
        AppConfig.settings.settings.apiEndpoint +
          'api/IpFiltering/CreateOrUpdateOrDeleteIpFiltering',
        param
      )
      .pipe(
        map(data => {
          let status: string =
            isCreateOrUpdateOrDelete < 0
              ? 'Create'
              : isCreateOrUpdateOrDelete > 0
              ? 'Update'
              : 'Delete';
          if (data <= 0) {
            this.toastrService.error(status + ' IP Filtering Failed', 'Error');
          } else {
            this.toastrService.success('IP Filtering ' + status + 'd Successfully', 'Success');
          }
          return data;
        })
      );
  }

  getIpFilteringById(id: number): Observable<IpFiltering> {
    return this.http
      .get<IpFiltering>(
        `${AppConfig.settings.settings.apiEndpoint}api/IpFiltering/GetIpFilteringById?clientInfoId=` +
          id
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  getIpFilterings(clientInfoId: number): Observable<IpFiltering[]> {
    return this.http
      .get<IpFiltering[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/IpFiltering/GetIpFilterings?clientInfoId=` +
          clientInfoId
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  setDataChanged(isChanged: boolean) {
    this.isDataChangedSubject.next(isChanged);
  }
}
